import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class SettingsService {
  constructor(private http: HttpClient) {}

  public fetchSettings(params: object = {}): Observable<any> {
    const url = `${environment.API_ENDPOINT}/conf`
    return this.http.get(url, params)
  }

  public updateSettings(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings`
    return this.http.post(url, params)
  }
}
